"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendshipsServiceDefinition = exports.SubscribeFriendshipEventsUpdatesResponse = exports.UpdateFriendshipResponse = exports.RequestEventsResponse = exports.UsersResponse = exports.InternalServerError = exports.TooManyRequestsError = exports.ForbiddenError = exports.UnauthorizedError = exports.BadRequestError = exports.Payload = exports.MutualFriendsPayload = exports.UpdateFriendshipPayload = exports.CancelPayload = exports.CancelResponse = exports.DeletePayload = exports.DeleteResponse = exports.RejectPayload = exports.RejectResponse = exports.AcceptPayload = exports.AcceptResponse = exports.RequestEvents = exports.Requests = exports.RequestPayload = exports.RequestResponse = exports.Users = exports.User = exports.FriendshipEventPayload = exports.FriendshipEventResponses = exports.FriendshipEventResponse = exports.protobufPackage = void 0;
const tslib_1 = require("tslib");
/* eslint-disable */
const long_1 = tslib_1.__importDefault(require("long"));
const minimal_1 = tslib_1.__importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "decentraland.social.friendships";
function createBaseFriendshipEventResponse() {
    return { request: undefined, accept: undefined, reject: undefined, delete: undefined, cancel: undefined };
}
var FriendshipEventResponse;
(function (FriendshipEventResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.request !== undefined) {
            RequestResponse.encode(message.request, writer.uint32(10).fork()).ldelim();
        }
        if (message.accept !== undefined) {
            AcceptResponse.encode(message.accept, writer.uint32(18).fork()).ldelim();
        }
        if (message.reject !== undefined) {
            RejectResponse.encode(message.reject, writer.uint32(34).fork()).ldelim();
        }
        if (message.delete !== undefined) {
            DeleteResponse.encode(message.delete, writer.uint32(42).fork()).ldelim();
        }
        if (message.cancel !== undefined) {
            CancelResponse.encode(message.cancel, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    }
    FriendshipEventResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFriendshipEventResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.request = RequestResponse.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.accept = AcceptResponse.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.reject = RejectResponse.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.delete = DeleteResponse.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.cancel = CancelResponse.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    FriendshipEventResponse.decode = decode;
    function fromJSON(object) {
        return {
            request: isSet(object.request) ? RequestResponse.fromJSON(object.request) : undefined,
            accept: isSet(object.accept) ? AcceptResponse.fromJSON(object.accept) : undefined,
            reject: isSet(object.reject) ? RejectResponse.fromJSON(object.reject) : undefined,
            delete: isSet(object.delete) ? DeleteResponse.fromJSON(object.delete) : undefined,
            cancel: isSet(object.cancel) ? CancelResponse.fromJSON(object.cancel) : undefined,
        };
    }
    FriendshipEventResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.request !== undefined &&
            (obj.request = message.request ? RequestResponse.toJSON(message.request) : undefined);
        message.accept !== undefined && (obj.accept = message.accept ? AcceptResponse.toJSON(message.accept) : undefined);
        message.reject !== undefined && (obj.reject = message.reject ? RejectResponse.toJSON(message.reject) : undefined);
        message.delete !== undefined && (obj.delete = message.delete ? DeleteResponse.toJSON(message.delete) : undefined);
        message.cancel !== undefined && (obj.cancel = message.cancel ? CancelResponse.toJSON(message.cancel) : undefined);
        return obj;
    }
    FriendshipEventResponse.toJSON = toJSON;
    function create(base) {
        return FriendshipEventResponse.fromPartial(base ?? {});
    }
    FriendshipEventResponse.create = create;
    function fromPartial(object) {
        const message = createBaseFriendshipEventResponse();
        message.request = (object.request !== undefined && object.request !== null)
            ? RequestResponse.fromPartial(object.request)
            : undefined;
        message.accept = (object.accept !== undefined && object.accept !== null)
            ? AcceptResponse.fromPartial(object.accept)
            : undefined;
        message.reject = (object.reject !== undefined && object.reject !== null)
            ? RejectResponse.fromPartial(object.reject)
            : undefined;
        message.delete = (object.delete !== undefined && object.delete !== null)
            ? DeleteResponse.fromPartial(object.delete)
            : undefined;
        message.cancel = (object.cancel !== undefined && object.cancel !== null)
            ? CancelResponse.fromPartial(object.cancel)
            : undefined;
        return message;
    }
    FriendshipEventResponse.fromPartial = fromPartial;
})(FriendshipEventResponse || (exports.FriendshipEventResponse = FriendshipEventResponse = {}));
function createBaseFriendshipEventResponses() {
    return { responses: [] };
}
var FriendshipEventResponses;
(function (FriendshipEventResponses) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.responses) {
            FriendshipEventResponse.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    FriendshipEventResponses.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFriendshipEventResponses();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.responses.push(FriendshipEventResponse.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    FriendshipEventResponses.decode = decode;
    function fromJSON(object) {
        return {
            responses: Array.isArray(object?.responses)
                ? object.responses.map((e) => FriendshipEventResponse.fromJSON(e))
                : [],
        };
    }
    FriendshipEventResponses.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        if (message.responses) {
            obj.responses = message.responses.map((e) => e ? FriendshipEventResponse.toJSON(e) : undefined);
        }
        else {
            obj.responses = [];
        }
        return obj;
    }
    FriendshipEventResponses.toJSON = toJSON;
    function create(base) {
        return FriendshipEventResponses.fromPartial(base ?? {});
    }
    FriendshipEventResponses.create = create;
    function fromPartial(object) {
        const message = createBaseFriendshipEventResponses();
        message.responses = object.responses?.map((e) => FriendshipEventResponse.fromPartial(e)) || [];
        return message;
    }
    FriendshipEventResponses.fromPartial = fromPartial;
})(FriendshipEventResponses || (exports.FriendshipEventResponses = FriendshipEventResponses = {}));
function createBaseFriendshipEventPayload() {
    return { request: undefined, accept: undefined, reject: undefined, delete: undefined, cancel: undefined };
}
var FriendshipEventPayload;
(function (FriendshipEventPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.request !== undefined) {
            RequestPayload.encode(message.request, writer.uint32(10).fork()).ldelim();
        }
        if (message.accept !== undefined) {
            AcceptPayload.encode(message.accept, writer.uint32(18).fork()).ldelim();
        }
        if (message.reject !== undefined) {
            RejectPayload.encode(message.reject, writer.uint32(34).fork()).ldelim();
        }
        if (message.delete !== undefined) {
            DeletePayload.encode(message.delete, writer.uint32(42).fork()).ldelim();
        }
        if (message.cancel !== undefined) {
            CancelPayload.encode(message.cancel, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    }
    FriendshipEventPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFriendshipEventPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.request = RequestPayload.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.accept = AcceptPayload.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.reject = RejectPayload.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.delete = DeletePayload.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.cancel = CancelPayload.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    FriendshipEventPayload.decode = decode;
    function fromJSON(object) {
        return {
            request: isSet(object.request) ? RequestPayload.fromJSON(object.request) : undefined,
            accept: isSet(object.accept) ? AcceptPayload.fromJSON(object.accept) : undefined,
            reject: isSet(object.reject) ? RejectPayload.fromJSON(object.reject) : undefined,
            delete: isSet(object.delete) ? DeletePayload.fromJSON(object.delete) : undefined,
            cancel: isSet(object.cancel) ? CancelPayload.fromJSON(object.cancel) : undefined,
        };
    }
    FriendshipEventPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.request !== undefined &&
            (obj.request = message.request ? RequestPayload.toJSON(message.request) : undefined);
        message.accept !== undefined && (obj.accept = message.accept ? AcceptPayload.toJSON(message.accept) : undefined);
        message.reject !== undefined && (obj.reject = message.reject ? RejectPayload.toJSON(message.reject) : undefined);
        message.delete !== undefined && (obj.delete = message.delete ? DeletePayload.toJSON(message.delete) : undefined);
        message.cancel !== undefined && (obj.cancel = message.cancel ? CancelPayload.toJSON(message.cancel) : undefined);
        return obj;
    }
    FriendshipEventPayload.toJSON = toJSON;
    function create(base) {
        return FriendshipEventPayload.fromPartial(base ?? {});
    }
    FriendshipEventPayload.create = create;
    function fromPartial(object) {
        const message = createBaseFriendshipEventPayload();
        message.request = (object.request !== undefined && object.request !== null)
            ? RequestPayload.fromPartial(object.request)
            : undefined;
        message.accept = (object.accept !== undefined && object.accept !== null)
            ? AcceptPayload.fromPartial(object.accept)
            : undefined;
        message.reject = (object.reject !== undefined && object.reject !== null)
            ? RejectPayload.fromPartial(object.reject)
            : undefined;
        message.delete = (object.delete !== undefined && object.delete !== null)
            ? DeletePayload.fromPartial(object.delete)
            : undefined;
        message.cancel = (object.cancel !== undefined && object.cancel !== null)
            ? CancelPayload.fromPartial(object.cancel)
            : undefined;
        return message;
    }
    FriendshipEventPayload.fromPartial = fromPartial;
})(FriendshipEventPayload || (exports.FriendshipEventPayload = FriendshipEventPayload = {}));
function createBaseUser() {
    return { address: "" };
}
var User;
(function (User) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    }
    User.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.address = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    User.decode = decode;
    function fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    }
    User.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    }
    User.toJSON = toJSON;
    function create(base) {
        return User.fromPartial(base ?? {});
    }
    User.create = create;
    function fromPartial(object) {
        const message = createBaseUser();
        message.address = object.address ?? "";
        return message;
    }
    User.fromPartial = fromPartial;
})(User || (exports.User = User = {}));
function createBaseUsers() {
    return { users: [] };
}
var Users;
(function (Users) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.users) {
            User.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    Users.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.users.push(User.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    Users.decode = decode;
    function fromJSON(object) {
        return { users: Array.isArray(object?.users) ? object.users.map((e) => User.fromJSON(e)) : [] };
    }
    Users.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        if (message.users) {
            obj.users = message.users.map((e) => e ? User.toJSON(e) : undefined);
        }
        else {
            obj.users = [];
        }
        return obj;
    }
    Users.toJSON = toJSON;
    function create(base) {
        return Users.fromPartial(base ?? {});
    }
    Users.create = create;
    function fromPartial(object) {
        const message = createBaseUsers();
        message.users = object.users?.map((e) => User.fromPartial(e)) || [];
        return message;
    }
    Users.fromPartial = fromPartial;
})(Users || (exports.Users = Users = {}));
function createBaseRequestResponse() {
    return { user: undefined, createdAt: 0, message: undefined };
}
var RequestResponse;
(function (RequestResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.createdAt !== 0) {
            writer.uint32(16).int64(message.createdAt);
        }
        if (message.message !== undefined) {
            writer.uint32(26).string(message.message);
        }
        return writer;
    }
    RequestResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.createdAt = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RequestResponse.decode = decode;
    function fromJSON(object) {
        return {
            user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
            createdAt: isSet(object.createdAt) ? Number(object.createdAt) : 0,
            message: isSet(object.message) ? String(object.message) : undefined,
        };
    }
    RequestResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        message.createdAt !== undefined && (obj.createdAt = Math.round(message.createdAt));
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    RequestResponse.toJSON = toJSON;
    function create(base) {
        return RequestResponse.fromPartial(base ?? {});
    }
    RequestResponse.create = create;
    function fromPartial(object) {
        const message = createBaseRequestResponse();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        message.createdAt = object.createdAt ?? 0;
        message.message = object.message ?? undefined;
        return message;
    }
    RequestResponse.fromPartial = fromPartial;
})(RequestResponse || (exports.RequestResponse = RequestResponse = {}));
function createBaseRequestPayload() {
    return { user: undefined, message: undefined };
}
var RequestPayload;
(function (RequestPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.message !== undefined) {
            writer.uint32(26).string(message.message);
        }
        return writer;
    }
    RequestPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RequestPayload.decode = decode;
    function fromJSON(object) {
        return {
            user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
            message: isSet(object.message) ? String(object.message) : undefined,
        };
    }
    RequestPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    RequestPayload.toJSON = toJSON;
    function create(base) {
        return RequestPayload.fromPartial(base ?? {});
    }
    RequestPayload.create = create;
    function fromPartial(object) {
        const message = createBaseRequestPayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        message.message = object.message ?? undefined;
        return message;
    }
    RequestPayload.fromPartial = fromPartial;
})(RequestPayload || (exports.RequestPayload = RequestPayload = {}));
function createBaseRequests() {
    return { total: 0, items: [] };
}
var Requests;
(function (Requests) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.total !== 0) {
            writer.uint32(8).int64(message.total);
        }
        for (const v of message.items) {
            RequestResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    }
    Requests.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequests();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.total = longToNumber(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.items.push(RequestResponse.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    Requests.decode = decode;
    function fromJSON(object) {
        return {
            total: isSet(object.total) ? Number(object.total) : 0,
            items: Array.isArray(object?.items) ? object.items.map((e) => RequestResponse.fromJSON(e)) : [],
        };
    }
    Requests.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        if (message.items) {
            obj.items = message.items.map((e) => e ? RequestResponse.toJSON(e) : undefined);
        }
        else {
            obj.items = [];
        }
        return obj;
    }
    Requests.toJSON = toJSON;
    function create(base) {
        return Requests.fromPartial(base ?? {});
    }
    Requests.create = create;
    function fromPartial(object) {
        const message = createBaseRequests();
        message.total = object.total ?? 0;
        message.items = object.items?.map((e) => RequestResponse.fromPartial(e)) || [];
        return message;
    }
    Requests.fromPartial = fromPartial;
})(Requests || (exports.Requests = Requests = {}));
function createBaseRequestEvents() {
    return { outgoing: undefined, incoming: undefined };
}
var RequestEvents;
(function (RequestEvents) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.outgoing !== undefined) {
            Requests.encode(message.outgoing, writer.uint32(10).fork()).ldelim();
        }
        if (message.incoming !== undefined) {
            Requests.encode(message.incoming, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    }
    RequestEvents.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestEvents();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.outgoing = Requests.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.incoming = Requests.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RequestEvents.decode = decode;
    function fromJSON(object) {
        return {
            outgoing: isSet(object.outgoing) ? Requests.fromJSON(object.outgoing) : undefined,
            incoming: isSet(object.incoming) ? Requests.fromJSON(object.incoming) : undefined,
        };
    }
    RequestEvents.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.outgoing !== undefined && (obj.outgoing = message.outgoing ? Requests.toJSON(message.outgoing) : undefined);
        message.incoming !== undefined && (obj.incoming = message.incoming ? Requests.toJSON(message.incoming) : undefined);
        return obj;
    }
    RequestEvents.toJSON = toJSON;
    function create(base) {
        return RequestEvents.fromPartial(base ?? {});
    }
    RequestEvents.create = create;
    function fromPartial(object) {
        const message = createBaseRequestEvents();
        message.outgoing = (object.outgoing !== undefined && object.outgoing !== null)
            ? Requests.fromPartial(object.outgoing)
            : undefined;
        message.incoming = (object.incoming !== undefined && object.incoming !== null)
            ? Requests.fromPartial(object.incoming)
            : undefined;
        return message;
    }
    RequestEvents.fromPartial = fromPartial;
})(RequestEvents || (exports.RequestEvents = RequestEvents = {}));
function createBaseAcceptResponse() {
    return { user: undefined };
}
var AcceptResponse;
(function (AcceptResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    AcceptResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcceptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    AcceptResponse.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    AcceptResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    AcceptResponse.toJSON = toJSON;
    function create(base) {
        return AcceptResponse.fromPartial(base ?? {});
    }
    AcceptResponse.create = create;
    function fromPartial(object) {
        const message = createBaseAcceptResponse();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    AcceptResponse.fromPartial = fromPartial;
})(AcceptResponse || (exports.AcceptResponse = AcceptResponse = {}));
function createBaseAcceptPayload() {
    return { user: undefined };
}
var AcceptPayload;
(function (AcceptPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    AcceptPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAcceptPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    AcceptPayload.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    AcceptPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    AcceptPayload.toJSON = toJSON;
    function create(base) {
        return AcceptPayload.fromPartial(base ?? {});
    }
    AcceptPayload.create = create;
    function fromPartial(object) {
        const message = createBaseAcceptPayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    AcceptPayload.fromPartial = fromPartial;
})(AcceptPayload || (exports.AcceptPayload = AcceptPayload = {}));
function createBaseRejectResponse() {
    return { user: undefined };
}
var RejectResponse;
(function (RejectResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    RejectResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRejectResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RejectResponse.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    RejectResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    RejectResponse.toJSON = toJSON;
    function create(base) {
        return RejectResponse.fromPartial(base ?? {});
    }
    RejectResponse.create = create;
    function fromPartial(object) {
        const message = createBaseRejectResponse();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    RejectResponse.fromPartial = fromPartial;
})(RejectResponse || (exports.RejectResponse = RejectResponse = {}));
function createBaseRejectPayload() {
    return { user: undefined };
}
var RejectPayload;
(function (RejectPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    RejectPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRejectPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RejectPayload.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    RejectPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    RejectPayload.toJSON = toJSON;
    function create(base) {
        return RejectPayload.fromPartial(base ?? {});
    }
    RejectPayload.create = create;
    function fromPartial(object) {
        const message = createBaseRejectPayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    RejectPayload.fromPartial = fromPartial;
})(RejectPayload || (exports.RejectPayload = RejectPayload = {}));
function createBaseDeleteResponse() {
    return { user: undefined };
}
var DeleteResponse;
(function (DeleteResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    DeleteResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    DeleteResponse.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    DeleteResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    DeleteResponse.toJSON = toJSON;
    function create(base) {
        return DeleteResponse.fromPartial(base ?? {});
    }
    DeleteResponse.create = create;
    function fromPartial(object) {
        const message = createBaseDeleteResponse();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    DeleteResponse.fromPartial = fromPartial;
})(DeleteResponse || (exports.DeleteResponse = DeleteResponse = {}));
function createBaseDeletePayload() {
    return { user: undefined };
}
var DeletePayload;
(function (DeletePayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    DeletePayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeletePayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    DeletePayload.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    DeletePayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    DeletePayload.toJSON = toJSON;
    function create(base) {
        return DeletePayload.fromPartial(base ?? {});
    }
    DeletePayload.create = create;
    function fromPartial(object) {
        const message = createBaseDeletePayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    DeletePayload.fromPartial = fromPartial;
})(DeletePayload || (exports.DeletePayload = DeletePayload = {}));
function createBaseCancelResponse() {
    return { user: undefined };
}
var CancelResponse;
(function (CancelResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    CancelResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    CancelResponse.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    CancelResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    CancelResponse.toJSON = toJSON;
    function create(base) {
        return CancelResponse.fromPartial(base ?? {});
    }
    CancelResponse.create = create;
    function fromPartial(object) {
        const message = createBaseCancelResponse();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    CancelResponse.fromPartial = fromPartial;
})(CancelResponse || (exports.CancelResponse = CancelResponse = {}));
function createBaseCancelPayload() {
    return { user: undefined };
}
var CancelPayload;
(function (CancelPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    }
    CancelPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    CancelPayload.decode = decode;
    function fromJSON(object) {
        return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
    }
    CancelPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        return obj;
    }
    CancelPayload.toJSON = toJSON;
    function create(base) {
        return CancelPayload.fromPartial(base ?? {});
    }
    CancelPayload.create = create;
    function fromPartial(object) {
        const message = createBaseCancelPayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        return message;
    }
    CancelPayload.fromPartial = fromPartial;
})(CancelPayload || (exports.CancelPayload = CancelPayload = {}));
function createBaseUpdateFriendshipPayload() {
    return { event: undefined, authToken: undefined };
}
var UpdateFriendshipPayload;
(function (UpdateFriendshipPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.event !== undefined) {
            FriendshipEventPayload.encode(message.event, writer.uint32(10).fork()).ldelim();
        }
        if (message.authToken !== undefined) {
            Payload.encode(message.authToken, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    }
    UpdateFriendshipPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFriendshipPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = FriendshipEventPayload.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.authToken = Payload.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    UpdateFriendshipPayload.decode = decode;
    function fromJSON(object) {
        return {
            event: isSet(object.event) ? FriendshipEventPayload.fromJSON(object.event) : undefined,
            authToken: isSet(object.authToken) ? Payload.fromJSON(object.authToken) : undefined,
        };
    }
    UpdateFriendshipPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.event !== undefined &&
            (obj.event = message.event ? FriendshipEventPayload.toJSON(message.event) : undefined);
        message.authToken !== undefined &&
            (obj.authToken = message.authToken ? Payload.toJSON(message.authToken) : undefined);
        return obj;
    }
    UpdateFriendshipPayload.toJSON = toJSON;
    function create(base) {
        return UpdateFriendshipPayload.fromPartial(base ?? {});
    }
    UpdateFriendshipPayload.create = create;
    function fromPartial(object) {
        const message = createBaseUpdateFriendshipPayload();
        message.event = (object.event !== undefined && object.event !== null)
            ? FriendshipEventPayload.fromPartial(object.event)
            : undefined;
        message.authToken = (object.authToken !== undefined && object.authToken !== null)
            ? Payload.fromPartial(object.authToken)
            : undefined;
        return message;
    }
    UpdateFriendshipPayload.fromPartial = fromPartial;
})(UpdateFriendshipPayload || (exports.UpdateFriendshipPayload = UpdateFriendshipPayload = {}));
function createBaseMutualFriendsPayload() {
    return { user: undefined, authToken: undefined };
}
var MutualFriendsPayload;
(function (MutualFriendsPayload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.authToken !== undefined) {
            Payload.encode(message.authToken, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    }
    MutualFriendsPayload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMutualFriendsPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = User.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.authToken = Payload.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    MutualFriendsPayload.decode = decode;
    function fromJSON(object) {
        return {
            user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
            authToken: isSet(object.authToken) ? Payload.fromJSON(object.authToken) : undefined,
        };
    }
    MutualFriendsPayload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.user !== undefined && (obj.user = message.user ? User.toJSON(message.user) : undefined);
        message.authToken !== undefined &&
            (obj.authToken = message.authToken ? Payload.toJSON(message.authToken) : undefined);
        return obj;
    }
    MutualFriendsPayload.toJSON = toJSON;
    function create(base) {
        return MutualFriendsPayload.fromPartial(base ?? {});
    }
    MutualFriendsPayload.create = create;
    function fromPartial(object) {
        const message = createBaseMutualFriendsPayload();
        message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
        message.authToken = (object.authToken !== undefined && object.authToken !== null)
            ? Payload.fromPartial(object.authToken)
            : undefined;
        return message;
    }
    MutualFriendsPayload.fromPartial = fromPartial;
})(MutualFriendsPayload || (exports.MutualFriendsPayload = MutualFriendsPayload = {}));
function createBasePayload() {
    return { synapseToken: undefined };
}
var Payload;
(function (Payload) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.synapseToken !== undefined) {
            writer.uint32(10).string(message.synapseToken);
        }
        return writer;
    }
    Payload.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.synapseToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    Payload.decode = decode;
    function fromJSON(object) {
        return { synapseToken: isSet(object.synapseToken) ? String(object.synapseToken) : undefined };
    }
    Payload.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.synapseToken !== undefined && (obj.synapseToken = message.synapseToken);
        return obj;
    }
    Payload.toJSON = toJSON;
    function create(base) {
        return Payload.fromPartial(base ?? {});
    }
    Payload.create = create;
    function fromPartial(object) {
        const message = createBasePayload();
        message.synapseToken = object.synapseToken ?? undefined;
        return message;
    }
    Payload.fromPartial = fromPartial;
})(Payload || (exports.Payload = Payload = {}));
function createBaseBadRequestError() {
    return { message: "" };
}
var BadRequestError;
(function (BadRequestError) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    }
    BadRequestError.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBadRequestError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    BadRequestError.decode = decode;
    function fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    }
    BadRequestError.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    BadRequestError.toJSON = toJSON;
    function create(base) {
        return BadRequestError.fromPartial(base ?? {});
    }
    BadRequestError.create = create;
    function fromPartial(object) {
        const message = createBaseBadRequestError();
        message.message = object.message ?? "";
        return message;
    }
    BadRequestError.fromPartial = fromPartial;
})(BadRequestError || (exports.BadRequestError = BadRequestError = {}));
function createBaseUnauthorizedError() {
    return { message: "" };
}
var UnauthorizedError;
(function (UnauthorizedError) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    }
    UnauthorizedError.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnauthorizedError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    UnauthorizedError.decode = decode;
    function fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    }
    UnauthorizedError.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    UnauthorizedError.toJSON = toJSON;
    function create(base) {
        return UnauthorizedError.fromPartial(base ?? {});
    }
    UnauthorizedError.create = create;
    function fromPartial(object) {
        const message = createBaseUnauthorizedError();
        message.message = object.message ?? "";
        return message;
    }
    UnauthorizedError.fromPartial = fromPartial;
})(UnauthorizedError || (exports.UnauthorizedError = UnauthorizedError = {}));
function createBaseForbiddenError() {
    return { message: "" };
}
var ForbiddenError;
(function (ForbiddenError) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    }
    ForbiddenError.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseForbiddenError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    ForbiddenError.decode = decode;
    function fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    }
    ForbiddenError.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    ForbiddenError.toJSON = toJSON;
    function create(base) {
        return ForbiddenError.fromPartial(base ?? {});
    }
    ForbiddenError.create = create;
    function fromPartial(object) {
        const message = createBaseForbiddenError();
        message.message = object.message ?? "";
        return message;
    }
    ForbiddenError.fromPartial = fromPartial;
})(ForbiddenError || (exports.ForbiddenError = ForbiddenError = {}));
function createBaseTooManyRequestsError() {
    return { message: "" };
}
var TooManyRequestsError;
(function (TooManyRequestsError) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    }
    TooManyRequestsError.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTooManyRequestsError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    TooManyRequestsError.decode = decode;
    function fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    }
    TooManyRequestsError.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    TooManyRequestsError.toJSON = toJSON;
    function create(base) {
        return TooManyRequestsError.fromPartial(base ?? {});
    }
    TooManyRequestsError.create = create;
    function fromPartial(object) {
        const message = createBaseTooManyRequestsError();
        message.message = object.message ?? "";
        return message;
    }
    TooManyRequestsError.fromPartial = fromPartial;
})(TooManyRequestsError || (exports.TooManyRequestsError = TooManyRequestsError = {}));
function createBaseInternalServerError() {
    return { message: "" };
}
var InternalServerError;
(function (InternalServerError) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    }
    InternalServerError.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalServerError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    InternalServerError.decode = decode;
    function fromJSON(object) {
        return { message: isSet(object.message) ? String(object.message) : "" };
    }
    InternalServerError.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    }
    InternalServerError.toJSON = toJSON;
    function create(base) {
        return InternalServerError.fromPartial(base ?? {});
    }
    InternalServerError.create = create;
    function fromPartial(object) {
        const message = createBaseInternalServerError();
        message.message = object.message ?? "";
        return message;
    }
    InternalServerError.fromPartial = fromPartial;
})(InternalServerError || (exports.InternalServerError = InternalServerError = {}));
function createBaseUsersResponse() {
    return {
        users: undefined,
        internalServerError: undefined,
        unauthorizedError: undefined,
        forbiddenError: undefined,
        tooManyRequestsError: undefined,
        badRequestError: undefined,
    };
}
var UsersResponse;
(function (UsersResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.users !== undefined) {
            Users.encode(message.users, writer.uint32(10).fork()).ldelim();
        }
        if (message.internalServerError !== undefined) {
            InternalServerError.encode(message.internalServerError, writer.uint32(18).fork()).ldelim();
        }
        if (message.unauthorizedError !== undefined) {
            UnauthorizedError.encode(message.unauthorizedError, writer.uint32(26).fork()).ldelim();
        }
        if (message.forbiddenError !== undefined) {
            ForbiddenError.encode(message.forbiddenError, writer.uint32(34).fork()).ldelim();
        }
        if (message.tooManyRequestsError !== undefined) {
            TooManyRequestsError.encode(message.tooManyRequestsError, writer.uint32(42).fork()).ldelim();
        }
        if (message.badRequestError !== undefined) {
            BadRequestError.encode(message.badRequestError, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    }
    UsersResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.users = Users.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.internalServerError = InternalServerError.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unauthorizedError = UnauthorizedError.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.forbiddenError = ForbiddenError.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.tooManyRequestsError = TooManyRequestsError.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.badRequestError = BadRequestError.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    UsersResponse.decode = decode;
    function fromJSON(object) {
        return {
            users: isSet(object.users) ? Users.fromJSON(object.users) : undefined,
            internalServerError: isSet(object.internalServerError)
                ? InternalServerError.fromJSON(object.internalServerError)
                : undefined,
            unauthorizedError: isSet(object.unauthorizedError)
                ? UnauthorizedError.fromJSON(object.unauthorizedError)
                : undefined,
            forbiddenError: isSet(object.forbiddenError) ? ForbiddenError.fromJSON(object.forbiddenError) : undefined,
            tooManyRequestsError: isSet(object.tooManyRequestsError)
                ? TooManyRequestsError.fromJSON(object.tooManyRequestsError)
                : undefined,
            badRequestError: isSet(object.badRequestError) ? BadRequestError.fromJSON(object.badRequestError) : undefined,
        };
    }
    UsersResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.users !== undefined && (obj.users = message.users ? Users.toJSON(message.users) : undefined);
        message.internalServerError !== undefined &&
            (obj.internalServerError = message.internalServerError
                ? InternalServerError.toJSON(message.internalServerError)
                : undefined);
        message.unauthorizedError !== undefined &&
            (obj.unauthorizedError = message.unauthorizedError
                ? UnauthorizedError.toJSON(message.unauthorizedError)
                : undefined);
        message.forbiddenError !== undefined &&
            (obj.forbiddenError = message.forbiddenError ? ForbiddenError.toJSON(message.forbiddenError) : undefined);
        message.tooManyRequestsError !== undefined &&
            (obj.tooManyRequestsError = message.tooManyRequestsError
                ? TooManyRequestsError.toJSON(message.tooManyRequestsError)
                : undefined);
        message.badRequestError !== undefined &&
            (obj.badRequestError = message.badRequestError ? BadRequestError.toJSON(message.badRequestError) : undefined);
        return obj;
    }
    UsersResponse.toJSON = toJSON;
    function create(base) {
        return UsersResponse.fromPartial(base ?? {});
    }
    UsersResponse.create = create;
    function fromPartial(object) {
        const message = createBaseUsersResponse();
        message.users = (object.users !== undefined && object.users !== null) ? Users.fromPartial(object.users) : undefined;
        message.internalServerError = (object.internalServerError !== undefined && object.internalServerError !== null)
            ? InternalServerError.fromPartial(object.internalServerError)
            : undefined;
        message.unauthorizedError = (object.unauthorizedError !== undefined && object.unauthorizedError !== null)
            ? UnauthorizedError.fromPartial(object.unauthorizedError)
            : undefined;
        message.forbiddenError = (object.forbiddenError !== undefined && object.forbiddenError !== null)
            ? ForbiddenError.fromPartial(object.forbiddenError)
            : undefined;
        message.tooManyRequestsError = (object.tooManyRequestsError !== undefined && object.tooManyRequestsError !== null)
            ? TooManyRequestsError.fromPartial(object.tooManyRequestsError)
            : undefined;
        message.badRequestError = (object.badRequestError !== undefined && object.badRequestError !== null)
            ? BadRequestError.fromPartial(object.badRequestError)
            : undefined;
        return message;
    }
    UsersResponse.fromPartial = fromPartial;
})(UsersResponse || (exports.UsersResponse = UsersResponse = {}));
function createBaseRequestEventsResponse() {
    return {
        events: undefined,
        internalServerError: undefined,
        unauthorizedError: undefined,
        forbiddenError: undefined,
        tooManyRequestsError: undefined,
    };
}
var RequestEventsResponse;
(function (RequestEventsResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.events !== undefined) {
            RequestEvents.encode(message.events, writer.uint32(10).fork()).ldelim();
        }
        if (message.internalServerError !== undefined) {
            InternalServerError.encode(message.internalServerError, writer.uint32(18).fork()).ldelim();
        }
        if (message.unauthorizedError !== undefined) {
            UnauthorizedError.encode(message.unauthorizedError, writer.uint32(26).fork()).ldelim();
        }
        if (message.forbiddenError !== undefined) {
            ForbiddenError.encode(message.forbiddenError, writer.uint32(34).fork()).ldelim();
        }
        if (message.tooManyRequestsError !== undefined) {
            TooManyRequestsError.encode(message.tooManyRequestsError, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    }
    RequestEventsResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestEventsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.events = RequestEvents.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.internalServerError = InternalServerError.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unauthorizedError = UnauthorizedError.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.forbiddenError = ForbiddenError.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.tooManyRequestsError = TooManyRequestsError.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    RequestEventsResponse.decode = decode;
    function fromJSON(object) {
        return {
            events: isSet(object.events) ? RequestEvents.fromJSON(object.events) : undefined,
            internalServerError: isSet(object.internalServerError)
                ? InternalServerError.fromJSON(object.internalServerError)
                : undefined,
            unauthorizedError: isSet(object.unauthorizedError)
                ? UnauthorizedError.fromJSON(object.unauthorizedError)
                : undefined,
            forbiddenError: isSet(object.forbiddenError) ? ForbiddenError.fromJSON(object.forbiddenError) : undefined,
            tooManyRequestsError: isSet(object.tooManyRequestsError)
                ? TooManyRequestsError.fromJSON(object.tooManyRequestsError)
                : undefined,
        };
    }
    RequestEventsResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.events !== undefined && (obj.events = message.events ? RequestEvents.toJSON(message.events) : undefined);
        message.internalServerError !== undefined &&
            (obj.internalServerError = message.internalServerError
                ? InternalServerError.toJSON(message.internalServerError)
                : undefined);
        message.unauthorizedError !== undefined &&
            (obj.unauthorizedError = message.unauthorizedError
                ? UnauthorizedError.toJSON(message.unauthorizedError)
                : undefined);
        message.forbiddenError !== undefined &&
            (obj.forbiddenError = message.forbiddenError ? ForbiddenError.toJSON(message.forbiddenError) : undefined);
        message.tooManyRequestsError !== undefined &&
            (obj.tooManyRequestsError = message.tooManyRequestsError
                ? TooManyRequestsError.toJSON(message.tooManyRequestsError)
                : undefined);
        return obj;
    }
    RequestEventsResponse.toJSON = toJSON;
    function create(base) {
        return RequestEventsResponse.fromPartial(base ?? {});
    }
    RequestEventsResponse.create = create;
    function fromPartial(object) {
        const message = createBaseRequestEventsResponse();
        message.events = (object.events !== undefined && object.events !== null)
            ? RequestEvents.fromPartial(object.events)
            : undefined;
        message.internalServerError = (object.internalServerError !== undefined && object.internalServerError !== null)
            ? InternalServerError.fromPartial(object.internalServerError)
            : undefined;
        message.unauthorizedError = (object.unauthorizedError !== undefined && object.unauthorizedError !== null)
            ? UnauthorizedError.fromPartial(object.unauthorizedError)
            : undefined;
        message.forbiddenError = (object.forbiddenError !== undefined && object.forbiddenError !== null)
            ? ForbiddenError.fromPartial(object.forbiddenError)
            : undefined;
        message.tooManyRequestsError = (object.tooManyRequestsError !== undefined && object.tooManyRequestsError !== null)
            ? TooManyRequestsError.fromPartial(object.tooManyRequestsError)
            : undefined;
        return message;
    }
    RequestEventsResponse.fromPartial = fromPartial;
})(RequestEventsResponse || (exports.RequestEventsResponse = RequestEventsResponse = {}));
function createBaseUpdateFriendshipResponse() {
    return {
        event: undefined,
        internalServerError: undefined,
        unauthorizedError: undefined,
        forbiddenError: undefined,
        tooManyRequestsError: undefined,
        badRequestError: undefined,
    };
}
var UpdateFriendshipResponse;
(function (UpdateFriendshipResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.event !== undefined) {
            FriendshipEventResponse.encode(message.event, writer.uint32(10).fork()).ldelim();
        }
        if (message.internalServerError !== undefined) {
            InternalServerError.encode(message.internalServerError, writer.uint32(18).fork()).ldelim();
        }
        if (message.unauthorizedError !== undefined) {
            UnauthorizedError.encode(message.unauthorizedError, writer.uint32(26).fork()).ldelim();
        }
        if (message.forbiddenError !== undefined) {
            ForbiddenError.encode(message.forbiddenError, writer.uint32(34).fork()).ldelim();
        }
        if (message.tooManyRequestsError !== undefined) {
            TooManyRequestsError.encode(message.tooManyRequestsError, writer.uint32(42).fork()).ldelim();
        }
        if (message.badRequestError !== undefined) {
            BadRequestError.encode(message.badRequestError, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    }
    UpdateFriendshipResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFriendshipResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = FriendshipEventResponse.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.internalServerError = InternalServerError.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unauthorizedError = UnauthorizedError.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.forbiddenError = ForbiddenError.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.tooManyRequestsError = TooManyRequestsError.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.badRequestError = BadRequestError.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    UpdateFriendshipResponse.decode = decode;
    function fromJSON(object) {
        return {
            event: isSet(object.event) ? FriendshipEventResponse.fromJSON(object.event) : undefined,
            internalServerError: isSet(object.internalServerError)
                ? InternalServerError.fromJSON(object.internalServerError)
                : undefined,
            unauthorizedError: isSet(object.unauthorizedError)
                ? UnauthorizedError.fromJSON(object.unauthorizedError)
                : undefined,
            forbiddenError: isSet(object.forbiddenError) ? ForbiddenError.fromJSON(object.forbiddenError) : undefined,
            tooManyRequestsError: isSet(object.tooManyRequestsError)
                ? TooManyRequestsError.fromJSON(object.tooManyRequestsError)
                : undefined,
            badRequestError: isSet(object.badRequestError) ? BadRequestError.fromJSON(object.badRequestError) : undefined,
        };
    }
    UpdateFriendshipResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.event !== undefined &&
            (obj.event = message.event ? FriendshipEventResponse.toJSON(message.event) : undefined);
        message.internalServerError !== undefined &&
            (obj.internalServerError = message.internalServerError
                ? InternalServerError.toJSON(message.internalServerError)
                : undefined);
        message.unauthorizedError !== undefined &&
            (obj.unauthorizedError = message.unauthorizedError
                ? UnauthorizedError.toJSON(message.unauthorizedError)
                : undefined);
        message.forbiddenError !== undefined &&
            (obj.forbiddenError = message.forbiddenError ? ForbiddenError.toJSON(message.forbiddenError) : undefined);
        message.tooManyRequestsError !== undefined &&
            (obj.tooManyRequestsError = message.tooManyRequestsError
                ? TooManyRequestsError.toJSON(message.tooManyRequestsError)
                : undefined);
        message.badRequestError !== undefined &&
            (obj.badRequestError = message.badRequestError ? BadRequestError.toJSON(message.badRequestError) : undefined);
        return obj;
    }
    UpdateFriendshipResponse.toJSON = toJSON;
    function create(base) {
        return UpdateFriendshipResponse.fromPartial(base ?? {});
    }
    UpdateFriendshipResponse.create = create;
    function fromPartial(object) {
        const message = createBaseUpdateFriendshipResponse();
        message.event = (object.event !== undefined && object.event !== null)
            ? FriendshipEventResponse.fromPartial(object.event)
            : undefined;
        message.internalServerError = (object.internalServerError !== undefined && object.internalServerError !== null)
            ? InternalServerError.fromPartial(object.internalServerError)
            : undefined;
        message.unauthorizedError = (object.unauthorizedError !== undefined && object.unauthorizedError !== null)
            ? UnauthorizedError.fromPartial(object.unauthorizedError)
            : undefined;
        message.forbiddenError = (object.forbiddenError !== undefined && object.forbiddenError !== null)
            ? ForbiddenError.fromPartial(object.forbiddenError)
            : undefined;
        message.tooManyRequestsError = (object.tooManyRequestsError !== undefined && object.tooManyRequestsError !== null)
            ? TooManyRequestsError.fromPartial(object.tooManyRequestsError)
            : undefined;
        message.badRequestError = (object.badRequestError !== undefined && object.badRequestError !== null)
            ? BadRequestError.fromPartial(object.badRequestError)
            : undefined;
        return message;
    }
    UpdateFriendshipResponse.fromPartial = fromPartial;
})(UpdateFriendshipResponse || (exports.UpdateFriendshipResponse = UpdateFriendshipResponse = {}));
function createBaseSubscribeFriendshipEventsUpdatesResponse() {
    return {
        events: undefined,
        internalServerError: undefined,
        unauthorizedError: undefined,
        forbiddenError: undefined,
        tooManyRequestsError: undefined,
    };
}
var SubscribeFriendshipEventsUpdatesResponse;
(function (SubscribeFriendshipEventsUpdatesResponse) {
    function encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.events !== undefined) {
            FriendshipEventResponses.encode(message.events, writer.uint32(10).fork()).ldelim();
        }
        if (message.internalServerError !== undefined) {
            InternalServerError.encode(message.internalServerError, writer.uint32(18).fork()).ldelim();
        }
        if (message.unauthorizedError !== undefined) {
            UnauthorizedError.encode(message.unauthorizedError, writer.uint32(26).fork()).ldelim();
        }
        if (message.forbiddenError !== undefined) {
            ForbiddenError.encode(message.forbiddenError, writer.uint32(34).fork()).ldelim();
        }
        if (message.tooManyRequestsError !== undefined) {
            TooManyRequestsError.encode(message.tooManyRequestsError, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    }
    SubscribeFriendshipEventsUpdatesResponse.encode = encode;
    function decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscribeFriendshipEventsUpdatesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.events = FriendshipEventResponses.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.internalServerError = InternalServerError.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unauthorizedError = UnauthorizedError.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.forbiddenError = ForbiddenError.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.tooManyRequestsError = TooManyRequestsError.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    SubscribeFriendshipEventsUpdatesResponse.decode = decode;
    function fromJSON(object) {
        return {
            events: isSet(object.events) ? FriendshipEventResponses.fromJSON(object.events) : undefined,
            internalServerError: isSet(object.internalServerError)
                ? InternalServerError.fromJSON(object.internalServerError)
                : undefined,
            unauthorizedError: isSet(object.unauthorizedError)
                ? UnauthorizedError.fromJSON(object.unauthorizedError)
                : undefined,
            forbiddenError: isSet(object.forbiddenError) ? ForbiddenError.fromJSON(object.forbiddenError) : undefined,
            tooManyRequestsError: isSet(object.tooManyRequestsError)
                ? TooManyRequestsError.fromJSON(object.tooManyRequestsError)
                : undefined,
        };
    }
    SubscribeFriendshipEventsUpdatesResponse.fromJSON = fromJSON;
    function toJSON(message) {
        const obj = {};
        message.events !== undefined &&
            (obj.events = message.events ? FriendshipEventResponses.toJSON(message.events) : undefined);
        message.internalServerError !== undefined &&
            (obj.internalServerError = message.internalServerError
                ? InternalServerError.toJSON(message.internalServerError)
                : undefined);
        message.unauthorizedError !== undefined &&
            (obj.unauthorizedError = message.unauthorizedError
                ? UnauthorizedError.toJSON(message.unauthorizedError)
                : undefined);
        message.forbiddenError !== undefined &&
            (obj.forbiddenError = message.forbiddenError ? ForbiddenError.toJSON(message.forbiddenError) : undefined);
        message.tooManyRequestsError !== undefined &&
            (obj.tooManyRequestsError = message.tooManyRequestsError
                ? TooManyRequestsError.toJSON(message.tooManyRequestsError)
                : undefined);
        return obj;
    }
    SubscribeFriendshipEventsUpdatesResponse.toJSON = toJSON;
    function create(base) {
        return SubscribeFriendshipEventsUpdatesResponse.fromPartial(base ?? {});
    }
    SubscribeFriendshipEventsUpdatesResponse.create = create;
    function fromPartial(object) {
        const message = createBaseSubscribeFriendshipEventsUpdatesResponse();
        message.events = (object.events !== undefined && object.events !== null)
            ? FriendshipEventResponses.fromPartial(object.events)
            : undefined;
        message.internalServerError = (object.internalServerError !== undefined && object.internalServerError !== null)
            ? InternalServerError.fromPartial(object.internalServerError)
            : undefined;
        message.unauthorizedError = (object.unauthorizedError !== undefined && object.unauthorizedError !== null)
            ? UnauthorizedError.fromPartial(object.unauthorizedError)
            : undefined;
        message.forbiddenError = (object.forbiddenError !== undefined && object.forbiddenError !== null)
            ? ForbiddenError.fromPartial(object.forbiddenError)
            : undefined;
        message.tooManyRequestsError = (object.tooManyRequestsError !== undefined && object.tooManyRequestsError !== null)
            ? TooManyRequestsError.fromPartial(object.tooManyRequestsError)
            : undefined;
        return message;
    }
    SubscribeFriendshipEventsUpdatesResponse.fromPartial = fromPartial;
})(SubscribeFriendshipEventsUpdatesResponse || (exports.SubscribeFriendshipEventsUpdatesResponse = SubscribeFriendshipEventsUpdatesResponse = {}));
exports.FriendshipsServiceDefinition = {
    name: "FriendshipsService",
    fullName: "decentraland.social.friendships.FriendshipsService",
    methods: {
        /** Get the list of friends for the authenticated user */
        getFriends: {
            name: "GetFriends",
            requestType: Payload,
            requestStream: false,
            responseType: UsersResponse,
            responseStream: true,
            options: {},
        },
        /** Get the list of mutual friends between the authenticated user and the one in the parameter */
        getMutualFriends: {
            name: "GetMutualFriends",
            requestType: MutualFriendsPayload,
            requestStream: false,
            responseType: UsersResponse,
            responseStream: true,
            options: {},
        },
        /** Get the list of request events for the authenticated user */
        getRequestEvents: {
            name: "GetRequestEvents",
            requestType: Payload,
            requestStream: false,
            responseType: RequestEventsResponse,
            responseStream: false,
            options: {},
        },
        /** Update friendship status: REQUEST, ACCEPT, REJECT, CANCEL, DELETE */
        updateFriendshipEvent: {
            name: "UpdateFriendshipEvent",
            requestType: UpdateFriendshipPayload,
            requestStream: false,
            responseType: UpdateFriendshipResponse,
            responseStream: false,
            options: {},
        },
        /** Subscribe to updates of friendship status: REQUEST, ACCEPT, REJECT, CANCEL, DELETE */
        subscribeFriendshipEventsUpdates: {
            name: "SubscribeFriendshipEventsUpdates",
            requestType: Payload,
            requestStream: false,
            responseType: SubscribeFriendshipEventsUpdatesResponse,
            responseStream: true,
            options: {},
        },
    },
};
const tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=friendships.gen.js.map